export default __webpack_public_path__ + "712a9139e9ff0a0da3ae6e4e9dbcac5b.png";